export default "<app-header-section></app-header-section>\n<app-listing-section></app-listing-section>\n<app-footer-section></app-footer-section>\n"